export default '/src/assets/webgl/caris_1/audios/en/bundle_1.mp3'